import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'debug', standalone: true })
export class DebugPipe implements PipeTransform {
  transform(value: any) {
    console.log(value);
  }
}
